import React from 'react';
import {Table} from "antd";
import {getGridTableHeight, amountFormatter} from '../Common/util';

/** -------------------------------------------------------------------------- **/
function Item({itemList, sumData, assetSum, assetList_u}) { 
    // assetList_u에 값이 없어서 오류가 작동하여 
    // asset_title 함수에 if문을 주석으로 처리 하였음.(144라인)
     const itemColumnData =  [
        {
            title: '분류',
            align: 'center',
            rowSpan: 2,
            colSpan: 2,
            children: [
                {
                    title: '',
                    dataIndex: 'measure_type',
                    key: 'measure_type',
                    width: '120px',
                    align: 'center',
                    fixed: 'left',
                    render: (value, row, index) => {

                        const obj = {
                            children : value,
                            props : {"rowSpan":0},
                        }
                        
                        if(index < 0 || value != itemList[index - 1]?.measure_type) {
                            for (
                                let i = 0;
                                index + i != itemList.length &&
                                value == itemList[index + i]?.measure_type;
                                i += 1
                            ) {
                                obj.props.rowSpan = i + 1;
                            }
                        }
                        return obj;
                    },
                    colSpan: 0,
                },
                {
                    title: ' ',
                    dataIndex: 'measure_cd',
                    key: 'measure_cd',
                    width: '70px',
                    align: 'center',
                    fixed: 'left',
                    colSpan: 0,
                },
            ]
        },
        {
            title: "진단 항목",
            dataIndex: 'measure_nm',
            key: 'measure_nm',
            width: '200px',
            align: 'left',
            fixed: 'left',
            ellipsis : true,
        },
        {
            title: '중요도',
            dataIndex: 'important_grd',
            key: 'important_grd',
            width: '70px',
            align: 'center',
            ellipsis : true,
            fixed: 'left',
        },
        {
            title: '등급 통계',
            align: 'center',
            children: [
                {
                    title: '전체',
                    dataIndex: 'stat_measure_total',
                    key: 'stat_measure_total',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '양호',
                    dataIndex: 'stat_measure_Y',
                    key: 'stat_measure_Y',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '취약',
                    dataIndex: 'stat_measure_N',
                    key: 'stat_measure_N',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '부분이행',
                    dataIndex: 'stat_measure_P',
                    key: 'stat_measure_P',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '해당없음',
                    dataIndex: 'stat_measure_NA',
                    key: 'stat_measure_NA',
                    width: '70px',
                    align: 'center',
                },
            ]
        },
        {
            title: '중요도 점수',
            align: 'center',
            children: [
                {
                    title: '전체',
                    dataIndex: 'stat_total_score',
                    key: 'stat_total_score',
                    width: '70px',
                    align: 'center',
                },
                {
                    title: '평가',
                    dataIndex: 'stat_eval_score',
                    key: 'stat_eval_score',
                    width: '70px',
                    align: 'center',
                },
            ]
        },
    ];

    function asset_title(title) {
        let tag_color ='';
        if (assetList_u.includes(title)) {
            tag_color = 'blue';
        } 
        // tag_color ='blue';
        return <span style={{color:tag_color}}>{title}</span>   
    }

    let assetColumns = [];
    let keys;
    let assetKeys = [];
    
    console.log("itemList", itemList);
    if(itemList.length > 0) {
        keys = Object.keys(itemList[0]);
        keys.map((key) => {
            if(key.substring(0,2) == '__') {
                assetKeys.push(key);
                assetColumns.push(
                    {
                        title: asset_title(key.substring(2)),
                        dataIndex: key,
                        key: key,
                        width: '50px',
                        align: 'center', 
                    }
                );
            }
          })
        //console.log(assetKeys);
    }

    const columns = [...itemColumnData];
    assetColumns.map((col) => {
      columns.push(col);
    })

    
    return (
        <>
            <div id="divTabs2" className="section" style={{height:getGridTableHeight(180), overflow:'hiddden'}}>
                <div className="sub_title">
                        {'■ 이행진단 항목별 통계'}
                        <span style={{color:'blue',paddingLeft:'20px'}}>※ 이행진단의 결과로 등록된 자산은 파란색상으로 표시됩니다.</span>
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table columns={columns}
                        dataSource={itemList}
                        pagination={false}
                        bordered size={"small"}
                        key={"itemList"}
                        className="sub_table"
                        scroll={{y: getGridTableHeight(300)}}
                        style={{height:getGridTableHeight(270)}}
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={4} className={'sum_col'}>{'합계'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={1} className={'sum_col'}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2} className={'sum_col'}>{amountFormatter(sumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(sumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{amountFormatter(sumData.eval_score)}</Table.Summary.Cell>
                                  {assetSum.map((asset, i) => {
                                        return (
                                            <Table.Summary.Cell index={10+i}>{amountFormatter(asset.sum)}</Table.Summary.Cell>
                                        )
                                    })
                                  }
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
            </div>
        </>
    );
}
export default Item;